"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _bootstrapUtils = require("./utils/bootstrapUtils");

var MediaList =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(MediaList, _React$Component);

  function MediaList() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = MediaList.prototype;

  _proto.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = (0, _objectWithoutProperties2.default)(_props, ["className"]);

    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
    return _react.default.createElement("ul", (0, _extends2.default)({}, elementProps, {
      className: (0, _classnames.default)(className, classes)
    }));
  };

  return MediaList;
}(_react.default.Component);

var _default = (0, _bootstrapUtils.bsClass)('media-list', MediaList);

exports.default = _default;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap/lib/MediaList.js
// module id = 344
// module chunks = 35783957827783 114276838955818